// ====================
// Negratta Theme JavaScript
// ====================

document.addEventListener('DOMContentLoaded', function() {
  // ----- Menú móvil -----
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.toggle('active');
      document.body.style.overflow = isOpen ? 'hidden' : '';
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  if (menuClose) {
    menuClose.addEventListener('click', closeMobileMenu);
  }

  // Cerrar menú al hacer clic fuera
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function(e) {
      if (e.target === this) closeMobileMenu();
    });
  }

  // Cerrar menú móvil con ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
      closeMobileMenu();
    }
  });

  // ----- Acordeones -----
  document.querySelectorAll('.accordion-item__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const expanded = this.getAttribute('aria-expanded') === 'true' || false;

      this.setAttribute('aria-expanded', !expanded);
      if (!expanded) {
        content.removeAttribute('hidden');
      } else {
        content.setAttribute('hidden', '');
      }
    });
  });

  // ----- Comprar ahora (botón principal y sticky): agrega vía Ajax y va directo a checkout -----
  document.querySelectorAll('[data-buy-now], [data-buy-now-sticky]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const form = document.getElementById('product-form');
      if (!form) return;
      const formData = new FormData(form);
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(response) { return response.json(); })
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function() {
          btn.disabled = false;
        });
    });
  });

  initCart();
  initProductGallery();
  initVariantPicker();
  initProductRecommendations();
  initQuantityStepper();

  // ----- Ordenar colección -----
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }
});

// ====================
// Stepper de cantidad (página de producto)
// ====================
function initQuantityStepper() {
  document.querySelectorAll('[data-quantity-stepper]').forEach(function(stepper) {
    const input = stepper.querySelector('input[type="number"]');
    const decreaseBtn = stepper.querySelector('[data-quantity-stepper-decrease]');
    const increaseBtn = stepper.querySelector('[data-quantity-stepper-increase]');
    if (!input) return;

    decreaseBtn.addEventListener('click', function() {
      const min = parseInt(input.min, 10) || 1;
      const current = parseInt(input.value, 10) || min;
      input.value = Math.max(min, current - 1);
    });

    increaseBtn.addEventListener('click', function() {
      const current = parseInt(input.value, 10) || 1;
      input.value = current + 1;
    });
  });
}

// ====================
// Galería de producto (soporta imagen, video y modelo 3D vía product.media)
// ====================
function selectProductMedia(mediaId) {
  if (!mediaId) return;
  mediaId = String(mediaId);

  document.querySelectorAll('[data-product-media]').forEach(function(block) {
    const isMatch = block.dataset.mediaId === mediaId;
    block.hidden = !isMatch;
    block.classList.toggle('is-active', isMatch);
  });

  document.querySelectorAll('[data-product-thumbnail]').forEach(function(thumb) {
    thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
  });
}

function initProductGallery() {
  const thumbnails = document.querySelectorAll('[data-product-thumbnail]');
  if (!thumbnails.length) return;

  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      selectProductMedia(thumb.dataset.mediaId);
    });
  });
}

// ====================
// Selector de variantes
// ====================
function initVariantPicker() {
  const wrapper = document.querySelector('[data-product-json]');
  if (!wrapper) return;

  let variants;
  try {
    variants = JSON.parse(wrapper.dataset.productJson);
  } catch (e) {
    return;
  }

  const form = wrapper.closest('form');
  const variantInput = form ? form.querySelector('[data-product-variant-id]') : null;
  const priceEl = document.querySelector('[data-product-price]');
  const comparePriceEl = document.querySelector('[data-product-compare-price]');
  const addToCartBtn = document.querySelector('[data-add-to-cart-button]');
  const addToCartText = document.querySelector('[data-add-to-cart-text]');
  const buyNowBtn = document.querySelector('[data-buy-now]');
  const skuEl = document.querySelector('[data-product-sku]');
  const stockEl = document.querySelector('[data-product-stock]');
  const currency = wrapper.dataset.currency;
  const locale = wrapper.dataset.locale;

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function getSelectedOptions() {
    const selected = [];
    wrapper.querySelectorAll('[data-option-index]').forEach(function(group) {
      const active = group.querySelector('.is-selected');
      if (active) selected[parseInt(group.dataset.optionIndex, 10)] = active.dataset.optionValue;
    });
    return selected;
  }

  function findVariant(selected) {
    return variants.find(function(v) {
      return [v.option1, v.option2, v.option3].every(function(opt, i) {
        return selected[i] === undefined || opt === selected[i];
      });
    });
  }

  function updateUI(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }
    if (addToCartBtn) addToCartBtn.disabled = !variant.available;
    if (buyNowBtn) buyNowBtn.disabled = !variant.available;
    if (addToCartText) {
      addToCartText.textContent = variant.available
        ? addToCartText.dataset.availableText
        : addToCartText.dataset.soldOutText;
    }
    if (variant.featured_media) {
      selectProductMedia(variant.featured_media.id);
    }
    if (skuEl) {
      if (variant.sku) {
        skuEl.textContent = skuEl.dataset.skuTemplate.replace('__SKU__', variant.sku);
        skuEl.hidden = false;
      } else {
        skuEl.hidden = true;
      }
    }
    if (stockEl) {
      const lowStock = variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10;
      if (lowStock) {
        stockEl.textContent = stockEl.dataset.stockTemplate.replace('__COUNT__', variant.inventory_quantity);
        stockEl.hidden = false;
      } else {
        stockEl.hidden = true;
      }
    }
  }

  wrapper.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-option-value]');
    if (!btn) return;
    const group = btn.closest('[data-option-index]');
    group.querySelectorAll('[data-option-value]').forEach(function(b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    updateUI(findVariant(getSelectedOptions()));
  });
}

// ====================
// Recomendaciones de producto
// ====================
function initProductRecommendations() {
  const trigger = document.querySelector('[data-product-recommendations]');
  if (!trigger || !trigger.dataset.url) return;

  fetch(trigger.dataset.url)
    .then(function(res) { return res.text(); })
    .then(function(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newRoot = doc.querySelector('[data-product-recommendations-root]');
      const currentRoot = document.querySelector('[data-product-recommendations-root]');
      if (newRoot && currentRoot) currentRoot.innerHTML = newRoot.innerHTML;
    })
    .catch(function() {});
}

// ====================
// Carrito (AJAX unificado)
// ====================
function initCart() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-drawer-close]');
  const cartOverlay = document.querySelector('[data-cart-drawer-overlay]');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (cartToggle) cartToggle.setAttribute('aria-expanded', 'true');
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      document.body.style.overflow = '';
      if (cartToggle) cartToggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('active')) {
      closeCartDrawer();
    }
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(counter) {
      counter.textContent = count;
    });
  }

  // Refresca las secciones del carrito presentes en la página actual (drawer y/o página /cart)
  function refreshCartSections(openDrawerAfter) {
    const targets = [];
    if (document.querySelector('[data-cart-drawer-body]')) {
      targets.push({ id: 'cart-drawer', selector: '[data-cart-drawer-body]' });
    }
    if (document.querySelector('[data-cart-page-body]')) {
      targets.push({ id: 'main-cart', selector: '[data-cart-page-body]' });
    }

    if (targets.length) {
      const ids = targets.map(function(t) { return t.id; }).join(',');
      fetch('/?sections=' + ids)
        .then(function(res) { return res.json(); })
        .then(function(data) {
          targets.forEach(function(t) {
            const html = data[t.id];
            if (!html) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newContent = doc.querySelector(t.selector);
            const currentEl = document.querySelector(t.selector);
            if (newContent && currentEl) currentEl.innerHTML = newContent.innerHTML;
          });
          if (openDrawerAfter) openCartDrawer();
        });
    } else if (openDrawerAfter) {
      openCartDrawer();
    }

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); })
      .catch(function() {});
  }

  // Añadir al carrito vía Ajax (abre el drawer en vez de navegar a /cart)
  document.addEventListener('submit', function(e) {
    if (e.target.getAttribute('id') !== 'product-form') return;
    e.preventDefault();
    const form = e.target;
    const submitBtn = form.querySelector('[type="submit"]');
    const formData = new FormData(form);
    if (submitBtn) submitBtn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(res) { return res.json(); })
      .then(function() { refreshCartSections(true); })
      .finally(function() {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  // Cambiar cantidad / quitar producto (delegado: funciona tras refrescos de contenido)
  document.addEventListener('click', function(e) {
    const decreaseBtn = e.target.closest('[data-quantity-decrease]');
    const increaseBtn = e.target.closest('[data-quantity-increase]');
    const removeBtn = e.target.closest('[data-remove-item]');
    if (!decreaseBtn && !increaseBtn && !removeBtn) return;

    const itemEl = (decreaseBtn || increaseBtn || removeBtn).closest('[data-item-key]');
    if (!itemEl) return;
    const key = itemEl.dataset.itemKey;

    let quantity;
    if (removeBtn) {
      quantity = 0;
    } else {
      const qtyEl = itemEl.querySelector('[data-item-quantity]');
      const current = parseInt(qtyEl.textContent, 10) || 0;
      quantity = decreaseBtn ? Math.max(0, current - 1) : current + 1;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(res) { return res.json(); })
      .then(function() { refreshCartSections(false); });
  });

  // ----- Añadir al carrito (sticky): reenvía el submit del formulario principal -----
  document.querySelectorAll('[data-add-to-cart-sticky]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const form = document.getElementById('product-form');
      if (form) {
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.click();
      }
    });
  });

  // ----- Inicializar contador desde el carrito actual -----
  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); })
    .catch(function() {});
}
